var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrown = function SvgFrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 8.667C22.695 8.667 8.667 22.695 8.667 40S22.694 71.334 40 71.334 71.333 57.305 71.333 40 57.305 8.667 40 8.667M4.667 40C4.666 20.486 20.486 4.667 40 4.667S75.333 20.487 75.333 40c0 19.514-15.82 35.334-35.333 35.334-19.514 0-35.333-15.82-35.333-35.334",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28 30a2 2 0 0 1 2-2h.032a2 2 0 1 1 0 4H30a2 2 0 0 1-2-2M48 30a2 2 0 0 1 2-2h.032a2 2 0 1 1 0 4H50a2 2 0 0 1-2-2M53.621 44.401l-24.5 8-1.242-3.802 24.5-8z",
    clipRule: "evenodd"
  })));
};
export default SvgFrown;